import axios from "../../../../../utils/authAxios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/EmployeeAdOverrideGroup";

export const getEmployeeAdOverrideGroup = async () => {
  const data = await axios.get(`${api_base_url}`);
  return data;
};

export const addEmployeeAdOverrideGroup = async (data) => {
  return await axios.post(`${api_base_url}`, data[0]);
};

export const updateEmployeeAdOverrideGroup = async (data) => {
  return await axios.put(`${api_base_url}`, data);
};

export const deleteEmployeeAdOverrideGroup = async (ids) => {
  await axios.put(`${api_base_url}/Deactivate`, ids);
};
